/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

import {conversationDetail} from '../../modules/conversation/conversationDetail';
import {conversationEvent} from '../../modules/event/conversationEvent';

export const getManyConversationEventsParams = z.object({
  conversationIds: z
    .string()
    .transform((val) => val.split(','))
    .pipe(
      z
        .array(z.string().uuid())
        .min(1, 'At least one conversation ID is required')
        .max(50, 'Maximum 50 conversation IDs allowed')
    )
    .openapi({
      description: 'Comma-separated list of conversation IDs to retrieve events from',
      example: '123e4567-e89b-12d3-a456-426614174000,456e7890-e12b-34c5-d678-90123456789a',
    }),
});

export type GetManyConversationEventsParams = z.infer<typeof getManyConversationEventsParams>;

export const getManyConversationEventsResponse = z.array(
  conversationDetail.extend({
    events: z.array(conversationEvent),
  })
);

export type GetManyConversationEventsResponse = z.infer<typeof getManyConversationEventsResponse>;
